import { render, staticRenderFns } from "./topicList.vue?vue&type=template&id=1bd800cb&scoped=true"
import script from "./topicList.vue?vue&type=script&lang=js"
export * from "./topicList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd800cb",
  null
  
)

export default component.exports